// Special screens of the conferences app for the admin: check-in desk, schedule editor, PC queue.
import { CheckIn } from './CheckIn.tsx';
import { PcQueue } from './PcQueue.tsx';
import { Schedule } from './Schedule.tsx';
export const conferenceScreens = { checkin: CheckIn, schedule: Schedule, pc: PcQueue };
/** Tabs of the order, ticket and company cards (Пр6). */
export { companyTabs, orderTabs, ticketTabs } from './SalesTabs.tsx';
/** Tab «Люди» of a talk (В6). */
export { TalkPeople } from './TalkPeople.tsx';
/** Tab «Просмотр» of a PC answer template (В9). */
export { PcTemplatePreview } from './PcTemplatePreview.tsx';
/** Tab «Команда» of an event (ЭС8). */
export { EventTeam } from './EventTeam.tsx';
/** Tab «Запуск» of an event (J1). */
export { EventLaunch } from './EventLaunch.tsx';
/** Tab «Сертификат» of an event (J8). */
export { EventCertificate } from './EventCertificate.tsx';
/** The first step of an empty «Проекты» (plan N1, R-E5). */
export { FirstConference } from './FirstConference.tsx';
/** The summary of a project above its tabs (R-E8). */
export { ProjectSummary } from './ProjectSummary.tsx';
/** Tab «События» of a contact: the history by the events of each project (R-E8). */
export { ContactEvents } from './ContactEvents.tsx';
/** Tabs «Цены», «Скидки», «Партнёры», «Площадка» of an event: its own settings (um/2026-10-30/03 п.4). */
export { eventSettingsTabs } from './EventSettings.tsx';
